module.exports = __webpack_public_path__ + "static/img/yuan_t.afd781d8.png";